import React, {useState, useEffect} from "react"
import {Outlet, Route, Routes, useLocation, useNavigate} from "react-router-dom"
import api, {requestFailed} from "./Scripts/api"
import "./index.css"
import NavMenu from "./Components/NavMenu"
import AccountButton from "./Components/AccountButton"
import Page404 from "./Pages/Page404"
import Home from "./Pages/Home"
import Explore from "./Pages/Explore"
import Post from "./Pages/Post"
import Create from "./Pages/Create"
import Challenge from "./Pages/Challenge"
import About from "./Pages/About"
import Help from "./Pages/Help"
import Legal from "./Pages/Legal"
import Login from "./Pages/Login"
import Account from "./Pages/Account"
import Profile from "./Pages/Profile"
import Guides from "./Pages/Guides"
import Liked from "./Pages/Liked"
import Settings from "./Pages/Settings"

function App() {

    const path = useLocation().pathname
    const location = path.split('/').filter((char) => char !== '')
    const navigate = useNavigate()
    const [account, setAccount] = useState()
    const [accountID, setAccountID] = useState()
    const [authChecked, setAuthChecked] = useState(false)
    const [navOpen, setNavOpen] = useState(false)
    const [connectionError, setConnectionError] = useState(false)

    const checkLogin = () => {
        api.get(`/api/login`).then((response) => {
            setConnectionError(false)
            if (response.data.loggedIn) {
                setAccount(response.data.account)
                setAccountID(response.data.accountID)
            }
            setAuthChecked(true)
        }).catch((error) => {
            requestFailed(error)
            setConnectionError(true)
            setAuthChecked(true)
        })
    }

    useEffect(() => {
        if (!location[0]) navigate("/home")
    }, [path])

    useEffect(() => {
        checkLogin()
    }, [])

    if (connectionError) {
        return <div className="app"><p id="connectionerror">something went wrong connecting to the server — please retry shortly.</p></div>
    }

    return (
        <Routes>
            <Route path='/' element={
                <div className="app">
                    <header>
                        <NavMenu setOpen={setNavOpen}></NavMenu>
                        <AccountButton account={account}></AccountButton>
                    </header>
                    <div className="page">
                        <Outlet context={{oc: {account: account, accountID: accountID, navOpen: navOpen, authChecked: authChecked}}}/>
                    </div>
                </div>
            }>

                <Route path="404" element={<Page404/>}></Route>
                <Route path="home" element={<Home/>}></Route>
                <Route path="explore" element={<Explore/>}>
                    <Route path="post/:postID" element={<Post/>}></Route>
                </Route>
                <Route path="explore/:tags" element={<Explore/>}>
                    <Route path="post/:postID" element={<Post/>}></Route>
                </Route>
                <Route path="post/:postID" element={<Post/>}></Route>
                <Route path="create" element={<Create/>}></Route>
                <Route path="challenge" element={<Challenge/>}></Route>
                <Route path="about" element={<About/>}></Route>
                <Route path="help" element={<Help/>}></Route>
                <Route path="legal" element={<Legal/>}></Route>
                <Route path="login" element={<Login/>}></Route>
                <Route path=":account" element={<Account/>}>
                    <Route path="profile" element={<Profile/>}>
                        <Route path="post/:postID" element={<Post/>}></Route>
                    </Route>
                    <Route path="guides" element={<Guides/>}>
                        <Route path="post/:postID" element={<Post/>}></Route>
                    </Route>
                    <Route path="liked" element={<Liked/>}>
                        <Route path="post/:postID" element={<Post/>}></Route>
                    </Route>
                    <Route path="settings" element={<Settings/>}></Route>
                </Route>
            </Route>
            <Route path="*" element={<Page404/>}></Route>
        </Routes>
    )
}

export default App;
